import React from 'react';

class Control extends React.Component {
    constructor(props) {
        super(props);

        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
    }

    handleKeyDown(e) {
        // Trigger a click event on 'enter'
        if (e.key === 'Enter') {
            e.preventDefault();

            const clickEvent = document.createEvent('MouseEvents');
            clickEvent.initEvent('click', true, true);
            this.refs.button.dispatchEvent(clickEvent);
        }

        if (this.props.onKeyDown && typeof this.props.onKeyDown === 'function') {
            this.props.onKeyDown(e);
        }
    }

    handleKeyUp(e) {
        // Trigger a click event on 'space'
        if (e.key === ' ') {
            e.preventDefault();

            const clickEvent = document.createEvent('MouseEvents');
            clickEvent.initEvent('click', true, true);
            this.refs.button.dispatchEvent(clickEvent);
        }

        if (this.props.onKeyUp && typeof this.props.onKeyUp === 'function') {
            this.props.onKeyUp(e);
        }
    }

    render() {
        const props = {};

        Object.keys(this.props).forEach(function(key){
            props[key] = this.props[key];
        }.bind(this));

        delete props.tag;
        props.ref = 'button';
        props.role = 'button';
        props.onKeyUp = this.handleKeyUp;
        props.onKeyDown = this.handleKeyDown;

        if (props.disabled) {
            delete props.tabIndex;
        }

        return React.createElement(this.props.tag, props);
    }
}

Control.defaultProps = {
    tag: 'div',
    tabIndex: 0,
};

export default Control;
